import { render } from "./RulesView.vue?vue&type=template&id=56c823cc"
import script from "./RulesView.vue?vue&type=script&lang=js"
export * from "./RulesView.vue?vue&type=script&lang=js"

import "./RulesView.vue?vue&type=style&index=0&id=56c823cc&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__